/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Playback_EndInputs */

const vi_tracking_playback_end = /** @type {(inputs: Tracking_Playback_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến`)
};

/**

* @param {Tracking_Playback_EndInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_playback_end = /** @type {((inputs?: Tracking_Playback_EndInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Playback_EndInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_playback_end(inputs)
});